module.exports = __webpack_public_path__ + "assets/start.fedbde3e.svg";